import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppointmentService } from '../../business-services/appointment.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-map-appointment-status',
  templateUrl: './map-appointment-status.component.html'
})
export class MapAppointmentStatusComponent implements OnInit,OnDestroy {
  statusList: any[] = []
  AOStatusList: any[] = []
  userRoleRightsDetails: UserRoleMenu;
  mapData: { id:number, selectedIds: number[] }[] = [];
  mapAOData: { id:number, selectedId: number}[] = [];
  mapEdit: { id:number,edit:boolean}[] = [];
  mapDelete: { id:number,delete:boolean}[] = [];
  currentlagSub: Subscription;

  constructor(private appointmentService: AppointmentService,
    private userService: UserDataService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    ) { }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.AppointmentStatusConfig);
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
    this.GetAllAppointmentStatus(x)
    })
  }
  ngOnDestroy(): void {
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
  }

  GetAllAppointmentStatus(languageCode) {
    this.appointmentService.GetAppointmentStatusList(languageCode).then(data => {
      if(data?.woStatusList)
      {
        if(data.woStatusList && data.woStatusList.length > 0){
          this.statusList = data.woStatusList.filter(x=>x.id !== 4)
          this.mapStatusData(this.statusList)
        }
        if(data.aoStatusList && data.aoStatusList.length > 0){
          this.AOStatusList = data.aoStatusList
        }
      }
    })
  }
  saveStatus(){
    let viewModel ={
      updateNextAvailableStatusRequests:this.mapData,
      updateWOAndAOStatusConfigurations:this.mapAOData,
      updateEditableStatusRequests:this.mapEdit,
      updateDeletableStatusRequests:this.mapDelete
    }
    this.appointmentService.UpdateAppointmentStatusList(viewModel).then((res)=>{
     if(res){
      let msg = this.translate.instant("lblStatusUpdated");
      this.toastr.success(msg)
     }
     else{
      let msg = this.translate.instant("lblStatusNotUpdated");
      this.toastr.error(msg)
     }
    })
  }
  mapStatusData(statusList:any[]){
    statusList.forEach(element => {
      let obj = {
        id: element.id,
        selectedIds: element.nextAvailableStatus === null ? [] : element.nextAvailableStatus.split(',').map(Number)
      }
      this.mapData.push(obj)
      let obje ={
        id: element.id,
        edit: element.isEditable
      }
      this.mapEdit.push(obje)
      let objd ={
        id: element.id,
        delete: element.isDeletable
      }
      this.mapDelete.push(objd)
      let objAO = {
        id: element.id,
        selectedId: element.appointmentStatusId
      }
      this.mapAOData.push(objAO)
    });
  }
}
